import config from '@/config'
import { isGokollab, isGokollabMobile } from '@ghl/clientportal-core/init'

function baseUrl(): string {
  if (isGokollab() && import.meta.env.DEV) {
    return 'http://localhost:3032'
  }
  return window.location.origin
}

export function currentUrl(): string {
  return window.location.href
}

export function externalPathRedirect(
  path?: string,
  query?: string,
  newTab?: boolean
): void {
  if (newTab) {
    window.open(
      `${baseUrl()}/${path ? path : ''}?${query ? query : ''}`,
      '_blank'
    )
  } else {
    window.location.href = `${baseUrl()}/${path ? path : ''}?${
      query ? query : ''
    }`
  }
}

export function getGokollabDomain() {
  return isGokollabMobile()
    ? config.GOKOLLAB_MOBILE_DOMAIN
    : config.GOKOLLAB_DOMAIN
}
